import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const COMPONENT_NAME = "IconButton";
const TYPES = {
  CONTAINED: "contained",
  STANDARD: "standard"
};
const SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
const BUTTON_SIZE = {
  [SIZE.SMALL]: "24px",
  [SIZE.MEDIUM]: "36px",
  [SIZE.LARGE]: "48px"
};
const BUTTON_CONTAINER_SIZE = {
  [SIZE.SMALL]: "20px",
  [SIZE.MEDIUM]: "30px",
  [SIZE.LARGE]: "40px"
};
const ICON_SIZE = {
  [SIZE.SMALL]: "12px",
  [SIZE.MEDIUM]: "18px",
  [SIZE.LARGE]: "24px"
};
const BUTTON_PADDING = {
  [SIZE.SMALL]: "2px",
  [SIZE.MEDIUM]: "3px",
  [SIZE.LARGE]: SpaceXxs
};
export {
  BUTTON_CONTAINER_SIZE,
  BUTTON_PADDING,
  BUTTON_SIZE,
  COMPONENT_NAME,
  ICON_SIZE,
  SIZE,
  TYPES
};
